<template>
  <header class="app-header navbar">
    <button class="navbar-toggler mobile-sidebar-toggler d-lg-none" type="button" @click="mobileSidebarToggle">
      <span class="navbar-toggler-icon"></span>
    </button>
    <!-- <b-link class="navbar-brand" to="#"></b-link> -->
    <button class="navbar-toggler sidebar-toggler d-md-down-none" type="button" @click="sidebarToggle">
      <span class="navbar-toggler-icon"></span>
    </button>
    <img src="/static/img/apptimus.png" alt="" class="logo-s mr-auto">
    <button class="navbar-toggler aside-menu-toggler d-md-down-none right-box" type="button" @click="asideToggle">
      <img class="profile-thumbnail" src="@/assets/default-profile.jpg">
      <span class='user-username'>
        {{user.name}}
      </span>
    </button>
  </header>
</template>
<script>
export default {
  name: 'c-header',
  methods: {
    sidebarToggle (e) {
      e.preventDefault()
      document.body.classList.toggle('sidebar-hidden')
    },
    sidebarMinimize (e) {
      e.preventDefault()
      document.body.classList.toggle('sidebar-minimized')
    },
    mobileSidebarToggle (e) {
      e.preventDefault()
      document.body.classList.toggle('sidebar-mobile-show')
    },
    asideToggle (e) {
      e.preventDefault()
      document.body.classList.toggle('aside-menu-hidden')
    }
  }
}
</script>

<style scoped>
  .profile-thumbnail {
    width: 40px;
    border-radius: 50%;
  }
  .right-box {
    margin-right: 20px;
  }
  .user-username {
    text-transform: capitalize;
  }
  .logo-s {
    height: 25px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Header.vue